import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import FormList from 'core/components/form-list';
import FormSectionWrapper from 'common/components/form-section-wrapper';
import Boat from './boat';
import AddBoat from './add-boat';
import useStyles from './boats-form.styles';

const BoatsForm = ({ id }) => {
  const classes = useStyles();
  const { values } = useFormikContext();
  const boats = (values.umbrellaCoverage?.watercraftHullLengths || []).filter(
    (hullLength) => hullLength !== null && hullLength !== undefined && hullLength !== ''
  );

  return (
    <FormSectionWrapper
      sectionTitle="Boats"
      sectionTooltip="Includes all boats powered by engines or sails, with a maximum length of 26 feet."
      headerClassName={classes.header}
      showTotal={false}
      totalLabel="Boats"
      totalCount={boats.length}
      emptyStateTitle="There are no boats added yet"
    >
      <FormList id={`${id}.watercraftHullLengths`} item={Boat} addForm={AddBoat} showRightLabel={false} maxSize={5} />
    </FormSectionWrapper>
  );
};

BoatsForm.propTypes = {
  id: PropTypes.string.isRequired
};

export default BoatsForm;
